import {
  FormControl,
  FormHelperText,
  TextField,
  Typography,
} from "@mui/material";
import { red } from "@mui/material/colors";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, parse } from "date-fns";
import { FC, useContext, useState } from "react";
import {
  Controller,
  FieldValues,
  useFormContext,
  useWatch,
} from "react-hook-form";
import {
  StateContext,
  StateContextType,
} from "../../context/ApplicationContext";
import HelperText from "./HelperText";
import { PPProps } from "./PPField";
import { evaluateExpression } from "../../functions/parser";

let fontColor: string = "text.secondary";

const PPTimePicker: FC<PPProps> = (props) => {
  const { control, getValues } = useFormContext();
  const stateCtx: StateContextType = useContext(StateContext);

  const requiredTokens: string[] = props.extendedAttributes["required"]
    ? props.extendedAttributes["required"].split(" ")
    : [];
  const watch: FieldValues = useWatch({ control, defaultValue: undefined });
  const isRequired: boolean = evaluateExpression(requiredTokens, watch);

  const appContext = stateCtx.applicationContext;
  const setAppContext = stateCtx.setApplicationContext;

  const storedDate: Date = parse(getValues(props.id), "hh:mm aa", new Date());
  const [value, setValue] = useState<Date | null>(
     storedDate.toString() !== 'Invalid Date' ? storedDate : null
  );

  return (
    <Controller
      render={({ field }) => {
        const isFieldInvalid: boolean =
          appContext.fieldState[field.name] !== undefined &&
          !appContext.fieldState[field.name];
        const isHideField: boolean =
          appContext.fieldHide[field.name] !== undefined &&
          appContext.fieldHide[field.name];
        const isDisabledField: boolean =
          appContext.fieldDisable[field.name] !== undefined &&
          appContext.fieldDisable[field.name];
        return (
          <FormControl error={isFieldInvalid} fullWidth>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <TimePicker
                label={
                  <Typography
                    sx={{ color: isFieldInvalid ? red.A700 : fontColor }}
                  >
                    {props.label + (isRequired ? " *" : "")}
                  </Typography>
                }
                value={value}
                onChange={(newValue) => {
                  setValue(newValue);
                  field.onChange(
                    newValue !== null && newValue.toString() !== "Invalid Date"
                      ? format(newValue, "hh:mm aa")
                      : null
                  );
                }}
                renderInput={(props) => (
                  <TextField
                    {...props}
                    id={props.id}
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </LocalizationProvider>
            <FormHelperText>
              {isFieldInvalid ? (
                "Field is required"
              ) : (
                <HelperText helperText={props.helperText}></HelperText>
              )}
            </FormHelperText>
          </FormControl>
        );
      }}
      name={props.id}
      control={control}
    />
  );
};

export default PPTimePicker;
//PPTimePicker.whyDidYouRender = true;
